import React, { useState, useEffect } from 'react';
import '../LoanDetails/LoanDetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import pdf_solid from '../../../images/icons/pdf.svg';
import Modal from '../../../common/components/Modal/modal';
import {
  faRupeeSign,
  faTrashAlt,
  faEdit
} from '@fortawesome/pro-solid-svg-icons';
import { numberFormat } from '../../../common/constants/NumberFormat';
import { deleteLoanDetails } from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
function LoanDetailsView(props) {
  const [ShowModal, setShowModal] = useState(false);
  const {
    setSteps,
    setDataView,
    data,
    setShow,
    setPopUpType,
    setPopUpText,
    indexVal,
    setTogetdata
  } = props;
  const HandleDeleteLoan = async () => {
    setShowModal(false);
    await setPopUpText(
      <p className="font-roboto font-normal text-sm" style={{ color: 'red' }}>
        Deleting Loan Details
      </p>
    );
    await setPopUpType('loading');
    setShow(true);
    let applicant = getApplicantionInfo();
    deleteLoanDetails(applicant.leadId, applicant.leadApplicantId, data.id)
      .then(async res => {
        if (res.error) {
          //throw new Error(res?.error?.data?.message);
          await setPopUpType('fail');
          await setPopUpText(res?.error?.data?.message);
          setShow(true);
        } else {
          await setSteps('showSavedLoanView');
        }
        setShow(false);
      })
      .catch(async err => {
        await setPopUpType('fail');
        await setPopUpText(err.toString());
        setShow(true);
      });
  };
  const askConfirmagionOfDeletion = () => {
    setShowModal(true);
  };
  const handleEditEvent = async () => {
    await setTogetdata([data]);
    await setSteps('showLoanDetails');
  };
  return (
    <React.Fragment>
      <div className="flex w-full relative m-auto mt-2 loan-bar md:p-2">
        <div className="w-6/12 text-black-400 font-bold">Your Saved Loans</div>
        <div className="w-6/12 text-black-400 text-right cursor-pointer">
          <span
            className="mr-2"
            onClick={e => {
              handleEditEvent();
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </span>
          <span onClick={e => askConfirmagionOfDeletion(e)}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </span>
        </div>
      </div>
      <div className="card_items mt-4 md:w-5/12 m-2">
        <p className="font-roboto font-normal text-sm text-green-900 py-2">
          Loan {indexVal + 1}
        </p>
        <div className={`p-2 md:5/12 text-black-400`}>
          <div className="flex w-full">
            <div className="w-6/12 text-black-400">
              <span className="px-1 float-left">
                {/*<img src="" alt="Loan Icon" />*/}
              </span>
              <span className="px-1 float-left">{data.loanType}</span>
            </div>
            <div className="w-6/12">
              <div className="w-full text-grey-600 pl-8 text-sm">
                Balance Amount
              </div>
              <div className="w-full text-green-1100 font-bold pl-8 text-xs">
                <FontAwesomeIcon icon={faRupeeSign} />{' '}
                {numberFormat(data.balanceAmount)}
              </div>
            </div>
          </div>
          <div className="flex w-full mt-4">
            <div className="w-6/12">
              <div className="w-full text-grey-600 text-sm">
                Sanction Amount
              </div>
              <div className="w-full font-bold text-xs">
                <FontAwesomeIcon icon={faRupeeSign} />{' '}
                {numberFormat(data.sanctionAmount)}
              </div>
            </div>
            <div className="w-6/12">
              <div className="w-full text-grey-600 text-sm">Current EMI</div>
              <div className="w-full font-bold text-xs">
                <FontAwesomeIcon icon={faRupeeSign} />
                {numberFormat(data.currentEmi)}
              </div>
            </div>
          </div>
          <div className="flex w-full mt-4">
            <div className="w-6/12">
              <div className="w-full text-grey-600 text-sm">Total Tenure</div>
              <div className="w-full font-bold text-xs">
                {data.totalTenure} Months
              </div>
            </div>
            <div className="w-6/12">
              <div className="w-full text-grey-600 text-sm">Balance Tenure</div>
              <div className="w-full font-bold text-xs">
                {data.balanceTenure} Months
              </div>
            </div>
          </div>
          <div className="flex w-full mt-4">
            <div className="w-full text-black-400">
              <span className="px-1 float-left text-sm">Lender Type: </span>
              <span className="px-1 float-left font-bold text-sm">
                {data.lender}
              </span>
            </div>
          </div>
          {data.sanctionDoc != null || data.statementDoc != null ? (
            <div className="flex-row w-full mt-4">
              <div className="w-full text-black-400 font-bold">
                Attatched Documents
              </div>
              {data.sanctionDoc != null ? (
                <div className="w-full p-1 text-black-400 ">
                  <p className="font-roboto font-normal text-sm text-grey-920  py-2">
                    Loan Sanction Letter
                  </p>
                  <div className="w-3/12 border-2 border-dotted border-orange-400 p-4 rounded-lg mt-2 text-center">
                    <a href={data?.sanctionDoc?.links[0]?.url} target="_blank">
                      <img src={pdf_solid} />
                    </a>
                  </div>
                </div>
              ) : null}
              {data.statementDoc != null ? (
                <div className="w-full p-1 text-black-400">
                  <p className="font-roboto font-normal text-grey-920 text-sm  py-2">
                    Loan Statement
                  </p>
                  <div className="w-3/12 border-2 border-dotted border-orange-400 p-4 rounded-lg mt-2 text-center">
                    <a href={data?.statementDoc?.links[0]?.url} target="_blank">
                      <img src={pdf_solid} />
                    </a>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <Modal show={ShowModal} setShow={setShowModal} noCloseBtn={false}>
        <div className="">
          <div className="w-full text-center">
            <p className="font-roboto font-normal tex-black-0 text-center">
              Are you sure?.. You want to delete this account?
            </p>
          </div>
          <div className="w-full flex mt-8">
            <button
              className="bg-red-100 text-white px-3 py-2 border border-balck-500 rounded-md font-roboto font-normal"
              onClick={() => HandleDeleteLoan()}
            >
              Yes! I want To Delete the Loan Details
            </button>
            <button
              className="ml-auto  border border-balck-500 rounded font-roboto font-normal px-3 py-2"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}
export default LoanDetailsView;
